import React from 'react';
import IcomoonReact from 'icomoon-react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Shimmer from '../../../../shared/_TBComponents/Shimmer';

import iconSet from '../../../../shared/images/teambuildr-selection.json';

const Container = styled('div')`
  position: relative;
  padding-top: 8px;
`;

const TextColumn = styled('div')`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-left: 7px;
`;

const Subtext = styled('div')`
  width: 100%;
  overflow: hidden;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-family: 'Nunito Sans';
  width: 500px;
  height: 20px;
  border-radius: 10px;
  margin-top: 5px;
`;

const NameText = styled('div')`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.text};
  font-family: 'Nunito Sans';
  width: 300px;
  border-radius: 10px;
  height: 20px;
`;

const ItemRow = styled('div')`
  display: flex;
  align-items: center;
`;

const IconContainer = styled('div')`
  background: ${(props) => props.background};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  height: 30px;
  width: 30px;
  border: ${(props) => `1px solid ${props.background}`};
`;

const ClickContainer = styled('div')`
  padding-left: 7px;
  display: flex;
  height: 53px;
  overflow: hidden;
  transition: height 0.3s ease;
  background: ${(props) => (props.isExpanded ? 'rgba(173, 202, 255, 0.2)' : 'none')};
  cursor: pointer;
  justify-content: space-between;
  align-items: center;
  .rc-menu {
    padding: 10px;
  }
`;

const ShimmerContent = ({ isExpanded, onClick }) => (
  <Container>
    <ClickContainer isExpanded={isExpanded} onClick={onClick}>
      <ItemRow>
        <Shimmer>
          <IconContainer>
            <IcomoonReact
              iconSet={iconSet}
              size={15}
              icon=''
              color='black'
            />
          </IconContainer>
        </Shimmer>
        <TextColumn>
          <Shimmer>
            <NameText />
          </Shimmer>
          <Shimmer>
            <Subtext />
          </Shimmer>
        </TextColumn>
      </ItemRow>
    </ClickContainer>
  </Container>
);

ShimmerContent.propTypes = {
  isExpanded: PropTypes.bool,
  onClick: PropTypes.func,
};

export default ShimmerContent;
